import { useRef, useEffect } from 'react';
import { MapPin, Phone, X, ArrowUpRight } from 'lucide-react';
export default function Contact({ isExpanded, setIsExpanded }) {
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    if (isExpanded && !element.open) element.showModal();
    if (!isExpanded && element.open) element.close();
    if (!isExpanded) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isExpanded]);
  return <dialog ref={dialog} className="contact-dialog" aria-labelledby="contact-title" onClose={() => setIsExpanded(false)} onClick={event => { if (event.target === dialog.current) setIsExpanded(false); }}>
    <div className="contact-inner"><button className="dialog-close" aria-label="Close contact details" onClick={() => setIsExpanded(false)}><X size={22} /></button>
      <p className="eyebrow">You’re always welcome</p><h2 id="contact-title">Let’s connect.</h2><p>Planning your first visit or joining us online? We’d love to hear from you.</p>
      <a className="contact-address" href="https://www.google.com/maps/search/?api=1&query=185+rue+des+Pyr%C3%A9n%C3%A9es+75020+Paris" target="_blank" rel="noreferrer"><MapPin /><span><strong>Visit us in Paris</strong><br />185 rue des Pyrénées, 75020 Paris</span><ArrowUpRight size={18} /></a>
      <p className="contact-label">GIVE US A CALL</p><div className="contact-phones">{['+33 7 69 93 33 75', '+33 6 28 68 73 62', '+33 6 46 10 64 55'].map(phone => <a key={phone} href={`tel:${phone.replaceAll(' ', '')}`}><Phone size={17} />{phone}<ArrowUpRight size={16} /></a>)}</div>
    </div>
  </dialog>;
}
